import { createAction } from 'redux-actions';

export const SET_SCENARIO = 'SET_SCENARIO';
export const setScenario = createAction(SET_SCENARIO);
